import { typeUtil } from "@repo/lib-common";


export class StoreData {
    
    orders:Array<typeUtil.StringOrUndefined>= new Array<typeUtil.StringOrUndefined>();

}